import { render, staticRenderFns } from "./Deptlist.vue?vue&type=template&id=f0dbf7f4&"
import script from "./Deptlist.vue?vue&type=script&lang=js&"
export * from "./Deptlist.vue?vue&type=script&lang=js&"
import style0 from "./Deptlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports